import { render, staticRenderFns } from "./EmailSet.vue?vue&type=template&id=144a2bb5"
import script from "./EmailSet.vue?vue&type=script&lang=js"
export * from "./EmailSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports